<template>
	<div class="actions-form">
		<div class="actions-form__actions" :class="newOffer ? 'new-user' : ''">
			<button
				class="actions-form__actions--btn outline"
				@click="handleDeleteModal()"
				v-if="!newOffer"
			>
				Excluir Oferta
			</button>
			<button
				class="actions-form__actions--btn"
				@click="validatePermissionsFormFields()"
				v-if="isEditing || newOffer"
			>
				Salvar
			</button>
		</div>
	</div>
</template>

<script>
export default {
	name: 'OfferActionsForm',
	components: {},
	props: {
		newOffer: {
			required: true,
		},
		isEditing: {
			required: true,
		},
	},
	methods: {
		handleDeleteModal() {
			this.$emit('handleDeleteModal');
		},
		validatePermissionsFormFields() {
			this.$emit('validatePermissionsFormFields');
		},
	},
};
</script>

<style lang="scss" scoped>
@import 'OfferActionsForm.scss';
</style>
